module.exports = __webpack_public_path__ + "img/loading.aac0bf0d.gif";